module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "br"
  }), _c('p', {
    staticClass: "br"
  }), _c('p', {
    staticClass: "br"
  }), _c('p', {
    staticClass: "br"
  }), _vm._v(" "), _c('p', {
    staticClass: "dt"
  }, [_c('strong', [_vm._v("Ma was propped up with extra pillows.")])]), _vm._v(" "), _c('p', {
    staticClass: "br"
  }), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_vm._v("Her night table was cluttered with various bottled remedies, her little helpers. I could see she had been crying. I suppose she could see I had been too. She patted the bed beside her.")]), _vm._v(" "), _c('p', [_vm._v("“What a blessing I have you, Poppy,” she said. “If you had been as favored with beauty as Honey you'dy soon make a good match and then what would I do, left all alone in the world?”")]), _vm._v(" "), _c('p', [_vm._v("I opened my mouth to say I didn't think Honey was all "), _c('em', [_vm._v("that")]), _vm._v(" favored with beauty, but Ma was getting into her stride.")]), _vm._v(" "), _c('p', [_vm._v("“But it's so clear to me now,” she continued. “I was given a beauty for the consolation her children will bring me, and I was given a plain one for companionship in my old age. How wise Nature is!”")]), _vm._v(" "), _c('p', [_vm._v("I said, “Does this mean I don't have to go to Cincinnati for a new nose?”")]), _vm._v(" "), _c('p', [_vm._v("“The nose is canceled,” she said. “And the singing lessons and the French and the cotillions. There's no sense in exerting ourselves in that direction anymore.”")]), _vm._v(" "), _c('p', [_vm._v("The great husband hunt had been called off.")]), _vm._v(" "), _c('p', {
    staticClass: "fmh1"
  }, [_vm._v("PRAISE FOR "), _c('em', [_vm._v("THE GREAT HUSBAND HUNT")])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“A delight…Graham's style is riveting, hilarious one-liners falling in quick succession.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_vm._v("—"), _c('em', [_vm._v("The Times")]), _vm._v(" (London)")]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Fresh, funny, and smart.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_vm._v("—"), _c('em', [_vm._v("Observer")]), _vm._v(" (London)")]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“An irrepressible adventurer, Poppy is a comic combination of innocence and pluck, but although this is a brisk, breezy read, it's also a novel with serious bite.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_vm._v("—"), _c('em', [_vm._v("Daily Mail")])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“A combination of stealthy nostalgia and tender comedy…she writes with pathos—a quality that is rarely taken seriously nowadays, perhaps because it usually relies on a quality of innocence for its effect.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_vm._v("—"), _c('em', [_vm._v("Times Literary Supplement")])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“It's the insight it offers into changing personal attitudes and family life during this turbulent period that makes it such a fascinating read. The central character is delightful and the characters she encounters are both accurate and colorful.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_vm._v("—"), _c('em', [_vm._v("Irish News")])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Compelling…doesn't disappoint.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_vm._v("—"), _c('em', [_vm._v("Hello!")])]), _vm._v(" "), _c('p', {
    staticClass: "fsq"
  }, [_vm._v("“Laurie Graham is a writer with a remarkably malleable comic voice.”")]), _vm._v(" "), _c('p', {
    staticClass: "fsqs"
  }, [_vm._v("—"), _c('em', [_vm._v("Guardian")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bf6584c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GreatHusbandHu_fron-1.vue
// module id = 66
// module chunks = 0